export default {
  en: {
    NotFoundMainTitle: 'Error 404',
    NotFoundMainSubtitle: 'Something went wrong.',
  },
};
